import React, { useEffect, useState } from "react";
// import QrReader from "react-qr-reader";
import { useDevices } from "@yudiel/react-qr-scanner";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import parse from "html-react-parser";
import { CRYPTO_SECRET_KEY, SOCKET_CHANNEL, SOCKET_URL, replaceNbsp,SOCKET_TRANSPORTS } from "src/_config";
import { useHistory, useParams } from "react-router";
import Sponsor from "src/components/common/Sponsor";
import { useAppEventGameListSelector } from "src/_common/hooks/selectors/eventSelector";
import QrscannerModal from "../modal/qrscannerModal";
import useSocket from "src/_common/hooks/useSocket";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import SuccessFailureModal from "../modal/successFailureModal";

import Cryptr from "cryptr";
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function TaskDetailsPage() {
  const [taskDetails, setTaskDetails] = useState<{
    id?: number;
    title?: string;
    description?: string;
    scan_user_count?: number;
    is_multiple_redeem?: number;
    performance_dtls?: { id?: number; scan_start?: number };
  } | null>(null);
  const deviceInfo = useDevices();
  const toast = useToaster();
  const { taskId } = useParams<{ taskId?: string }>();
  const eventAction = useAppEventAction();
  const history = useHistory();
  const taskList = useAppEventGameListSelector() as Array<Record<string, unknown> & { id?: number }> | null;
  const [showQrscannerModal, setShowQrscannerModal] = useState<boolean>(false);
  const [showSuccessFailureModal, setShowSuccessFailureModal] = useState<boolean>(false);
  const [successFailureData, setSuccessFailureData] = useState<{ type?: string; point?: number; message?: string } | null>(null);

  const openQrscannerModal = () => {
    setShowQrscannerModal(true);
  };

  const closeQrscannerModal = () => {
    setShowQrscannerModal(false);
  };

  const openSuccessFailureModal = (data: { type?: string; point?: number; message?: string }) => {
    setShowSuccessFailureModal(true);
    setSuccessFailureData(data);
  };

  const closeSuccessFailureModal = () => {
    setShowSuccessFailureModal(false);
    setSuccessFailureData(null);
  };

  // const handleScan = (scanData: any) => {
  //   // setLoadingScan(true);
  //   // console.log(`loaded data data`, scanData);
  //   if (scanData[0]?.rawValue) {
  //     let params: any = {
  //       rodeo_event_id: parseInt(cryptr.decrypt(eventId)),
  //       performance_id: parseInt(cryptr.decrypt(performanceId)),
  //       task_id: parseInt(cryptr.decrypt(taskId)),
  //       qr_code: scanData[0]?.rawValue,
  //     };
  //     if (!userDetails) {
  //       if (guestUserId) {
  //         params["guest_user_id"] = guestUserId;
  //       }
  //     }
  //     eventApi.callScanQRCode(
  //       params,
  //       (message: any, resp: any) => {
  //         console.log({ resp });
  //         userAction.guestUserId(resp);
  //         if (resp.guest_user_id) {
  //           localStorage.setItem("guestUserId", resp.guest_user_id);
  //         } else {
  //           localStorage.removeItem("guestUserId");
  //         }
  //         setStartScan(false);
  //         toast.success(message);
  //       },
  //       (message: any) => {
  //         toast.error(message);
  //       }
  //     );
  //   }
  // };

  const openScanner = () => {
    if (deviceInfo?.length) {
      // setStartScan(!startScan);
      openQrscannerModal();
    } else {
      toast.error("Your device doesn't support scanning");
    }
  };

  const goBack = () => {
    // if (history.length > 1) {
    history.goBack();
    // } else {
    //   history.push(URLS.HOME);
    // }
  };

  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    withCredentials: true,
    transports: SOCKET_TRANSPORTS,
    upgrade: true,        // Enable transport upgrades (polling -> websocket)
    rememberUpgrade: true, // Remember successful upgrades for faster reconnection
  });

  useEffect(() => {
    socket.connect();

    //Status Change Socket
    socket.on(SOCKET_CHANNEL.START_STOP_RP_EVENT, (data: Record<string, unknown> & { performance?: { id?: number; scan_start?: number } }) => {
      console.log({ data });
      // setSocketData(data);
      if (taskDetails && data && taskDetails?.performance_dtls?.id == data?.performance?.id) {
        const t = { ...taskDetails };
        t.performance_dtls = {
          ...t.performance_dtls,
          scan_start: data.performance?.scan_start,
        };
        console.log({ t });
        // setTaskDetails(t);
        eventAction.updateTaskListScanStart(t);
        // setSocketData(null);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [socket, taskDetails]);

  useEffect(() => {
    console.log(deviceInfo);
  }, [deviceInfo]);

  useEffect(() => {
    if (taskList?.length && taskId) {
      const task_id = parseInt(cryptr.decrypt(taskId));
      console.log({ taskList });
      const t = taskList.find((x) => x.id == task_id) as typeof taskDetails;
      setTaskDetails(t);
    }
  }, [taskList, taskId]);

  return (
    <React.Fragment>
      <div>
        <h2 className="page-title text-left">
          <a onClick={goBack} className="back-history">
            <img src="/images/left-white.svg" alt="back" />
          </a>
          {taskDetails?.title || <span>Back</span>}
          <hr className="color-white" />
        </h2>
        <hr className="color-white" />
        <div className="form-box-new">
          <div className="row text-white">
            {taskDetails?.description ? parse(replaceNbsp(taskDetails?.description)) : ""}
          </div>
        </div>
        {(taskDetails?.scan_user_count ?? 0) > 0 ? (
          <>
            <h2 className="text-center color-red" style={{ fontWeight: 600 }}>
              {/* <i className="fa fa-check pr-2" aria-hidden="true" /> */}
              <i
                className="fa-solid fa-circle-check"
                style={{ color: "white", backgroundColor: "#ee3a43", borderRadius: "50%" }}
              />
              {" Task Complete"}
            </h2>
          </>
        ) : null}
        {(taskDetails?.is_multiple_redeem == 1 ||
          (taskDetails?.is_multiple_redeem == 0 && (taskDetails?.scan_user_count ?? 0) < 1)) &&
          taskDetails?.performance_dtls?.scan_start == 1 && (
            <div className="join-now-btn-wrap">
              <button className={window.innerWidth > window.innerHeight ? "w-25" : "w-75"} onClick={openScanner}>
                {"Open Scanner"}
              </button>
            </div>
          )}
        {/* {startScan && (
          <>
            <Scanner onScan={(result: any) => handleScan(result)} />
          </>
        )}
        {loadingScan && <p>Loading</p>}
        {data !== "" && <p>{data}</p>} */}
      </div>
      <Sponsor />
      {showQrscannerModal && (
        <QrscannerModal
          shouldShow={showQrscannerModal}
          onClose={closeQrscannerModal}
          taskDetails={taskDetails || {}}
          openSuccessFailureModal={openSuccessFailureModal}
        />
      )}
      {showSuccessFailureModal && successFailureData && (
        <SuccessFailureModal
          shouldShow={showSuccessFailureModal}
          onClose={closeSuccessFailureModal}
          data={successFailureData}
          openQrscannerModal={openQrscannerModal}
        />
      )}
    </React.Fragment>
  );
}
